//State
const state = {
  drawer: false,
};

//Getters
const getters= {
  getNavDrawer(state) {
    return state.drawer
  },
};

//Actions
const actions = {
  open({commit}){
    commit('SET_DRAWER', true)
  }
};

//Mutations
const mutations = {
  SET_DRAWER (state, value) {
    state.drawer = value
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}